<script lang="ts">
  import LoadingPlaceholder from "@kontextwerk/control-web-frame/components/ui/LoadingPlaceholder.svelte"
  import CaseCommunicationsHeader from "./_modules/case-communications-header"
  import CommunicationPlanTable from "../../_shared/_modules/communication-plan-table"
  import type { CommunicationPlanFilterDisplayMode } from "../../_shared/_logic/communication-plan-table-contract"
  import type { PageContext } from "../../navigation"

  const { pageContext } = $props<{
    pageContext: PageContext
  }>()

  const organization = $derived(pageContext.organization)
  let filterMode = $state<CommunicationPlanFilterDisplayMode>("compact")
</script>

<div class="communication-panel">
  <CaseCommunicationsHeader
    title="Terminkommunikation"
    helpModalTextId="appointmentCommunications"
    {filterMode}
    onFilterModeChange={(mode) => {
      filterMode = mode
    }}
  />
  {#if organization?.id}
    <CommunicationPlanTable organizationId={organization.id} {filterMode} />
  {:else}
    <LoadingPlaceholder rows={3} maxWidth="720px" />
  {/if}
</div>

<style lang="less">
  .communication-panel {
    display: flex;
    flex-direction: column;
    gap: 0.8rem;
  }
</style>
